import React from 'react';
import {Link} from 'react-router-dom';
import {Row, Col, Button, Alert} from 'react-bootstrap';
// src
import {ORDERS_SUMMARY_PATH as path, LANDING, ORDERS_SUMMARY} from '../../routes/routes_production.js';
import {PostRequest} from '../../api/PostRequest.js';
import * as panels from './formFields.js';
import PageHeader from '../PageHeader.js';
import PanelPrenotazione from './Panels/PanelPrenotazione.js';
import PanelProdotti from './Panels/PanelProdotti/PanelProdotti.js';
import PanelPagamento from './Panels/PanelPagamento.js';
import PanelIndirizzo from './Panels/PanelIndirizzo.js';
import PanelCliente from './Panels/PanelCliente/PanelCliente.js';
import ResponseBox, {FeedbackAlertBox} from './Response/ResponseBox.js';
import {getSelValueEsteso} from './UtilOrder.js';
// css
import '../styles/sharedComponentsStyles.css';
import '../styles/commonStyles.css';
import './styles/ordersStyles.css';

class EditOrder extends React.Component {
  constructor(props) {
    super(props);

    const { state } = this.props.location;
    const booking = (state!==undefined)? state.booking : null;
    const viewOnly = (state!==undefined)? state.viewOnly : null;

    this.state = {
      booking,
      viewOnly,
      loading: true,
      order: null
    }    

    this.saveOrderToState = this.saveOrderToState.bind(this);
  }

  componentDidMount() {
    PostRequest(path, {"request": "getSingleOrder", "booking": this.state.booking})
    .then((res) => {   
      if(res[0] === "error") {
        this.setState({loading: false, order: null})
      } else {                    
        this.saveOrderToState(res);          
     }
    })
    .catch((err) => { 
      console.log(err);          
    });
  }
  
  saveOrderToState(res) {  
    let panPrenotazione = [];
    let panPagamento = [];
    let panProdotti = [];
    let panIndirizzo = [];
    let panCliente = [];
    let panNuovoCliente = [];

    let order = res[0];
    for (let name of Object.keys(order)) {       
      // Prenotazione
      if(panels.PANEL_PRENOTAZIONE.indexOf(name) !== -1) {                    
        panPrenotazione[name] = (name==='dataSerata')? 
          inputParsers['reverseDate'](order[name]) : order[name];                      
      } else    
      // Prodotti
      if(panels.PANEL_PRODOTTI.indexOf(name) !== -1
        || name.match(/codArt_*/) || name.match(/descArt_*/) 
        || name.match(/noteArt_*/) || name.match(/dimArt_*/)
        || name.match(/pesoArt_*/)) {
        panProdotti[name] = order[name];             
      } 
      // Pagamento
      if(panels.PANEL_PAGAMENTO.indexOf(name) !== -1) {            
        panPagamento[name] = order[name];
      } else 
      // Indirizzo
      if(panels.PANEL_INDIRIZZO.indexOf(name) !== -1) {      
        panIndirizzo[name] = order[name];
      } else 
      // Cliente
      if(panels.PANEL_CLIENTE.indexOf(name) !== -1) {          
        panCliente[name] = order[name];
      } 
      // Nuovo cliente
      if(panels.PANEL_NUOVO_CLIENTE.indexOf(name) !== -1) {          
        panNuovoCliente[name] = order[name];
      } 
    }

    this.setState({
      order: true,
      loading: false,
      panPrenotazione: panPrenotazione,
      panPagamento: panPagamento,
      panProdotti: panProdotti,
      panIndirizzo: panIndirizzo,
      panCliente: panCliente,
      panNuovoCliente: panNuovoCliente,
    });
  }

  render() {
    const { 
      viewOnly,
      loading, 
      order,
      panPrenotazione, 
      panPagamento, 
      panProdotti,
      panIndirizzo, 
      panCliente,
      panNuovoCliente
    } = this.state;    

    if (loading) 
      return null;

    return (      
      <Col xs={12}>
        <PageHeader title="Nuovo ordine" badge={viewOnly? "Sola lettura" : "Modifica in corso"}
                    subTitle="Compila i dati del modulo" />
        {order
          ? (
              <EditOrderForm panPrenotazione={panPrenotazione} 
                             panProdotti={panProdotti}
                             panPagamento={panPagamento} 
                             panIndirizzo={panIndirizzo}
                             panCliente={panCliente} 
                             panNuovoCliente={panNuovoCliente} 
                             viewOnly={viewOnly} />
            )
          : (
              <FeedbackAlertBox margin="mt-2" alertStyle="danger">
                <p>
                  <strong>Oops, qualcosa non va! </strong>
                  Non ho potuto caricare l'ordine da modificare.<br/>
                  <Link to={LANDING}>Nuovo ordine</Link><br/>                 
                  <Link to={".."+ORDERS_SUMMARY}>Riepilogo ordini</Link><br/>       
                </p>
              </FeedbackAlertBox>
            )
        }
      </Col>
    );    
  }
}

class EditOrderForm extends React.Component {
  constructor(props) {
    super(props);   
    
    this.state={       
      panPrenotazione: this.props.panPrenotazione,
      panProdotti: this.props.panProdotti,
      panPagamento: this.props.panPagamento,
      panIndirizzo: this.props.panIndirizzo,
      panCliente: this.props.panCliente,      
      panNuovoCliente: this.props.panNuovoCliente,      
      needsTwoContacts: false,  
      needsCalculation: true,    
    };         
    
    this.toggleNeedsTwoContacts = this.toggleNeedsTwoContacts.bind(this);
    this.toggleNeedsCalculation = this.toggleNeedsCalculation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {   
    const { 
      res, requestBody, invalid, displayErrors, 
      panPrenotazione, panPagamento, panProdotti, panIndirizzo, panCliente, panNuovoCliente,
      needsTwoContacts, needsCalculation,     
    } = this.state;          

    return (
      <Row className="noNegativeMargin addFooterMargin">   
      <Col xs={12}>
        <form className={displayErrors?'displayErrors' : ''} onSubmit={this.handleSubmit}               
              ref="refForm" id="edit-order-form" noValidate>          
          <Row className="show-grid">
            <PanelPrenotazione panPrenotazione={panPrenotazione} editMode="true" />
          </Row>

          <Row className="show-grid">
            <PanelProdotti 
              panProdotti={panProdotti} editMode="true"
              toggleNeedsCalculation={this.toggleNeedsCalculation} 
            />
          </Row>

          <Row className="show-grid">
            <PanelPagamento 
              panPagamento={panPagamento} editMode="true"
              toggleNeedsTwoContacts={this.toggleNeedsTwoContacts} 
              toggleNeedsCalculation={this.toggleNeedsCalculation}
              needsCalculation={needsCalculation}
            />
          </Row>
          
          <Row className="show-grid">
            <PanelCliente panCliente={panCliente} panIndirizzo={panIndirizzo} panNuovoCliente={panNuovoCliente} editMode="true"
                          needsTwoContacts={needsTwoContacts} />
          </Row>

          <Row className="show-grid">
            <PanelIndirizzo panIndirizzo={panIndirizzo} editMode="true" />
          </Row>

          <Row className="show-grid">
            <Col xs={12} lg={12}>
              {
                (this.props.viewOnly)?
                  <Alert bsStyle="warning">
                    <p>Questo ordine è aperto in modalità sola lettura,
                       eventuali modifiche non verranno registrate.<br/>
                      <Link to={".."+ORDERS_SUMMARY}>Riepilogo ordini</Link>
                    </p>
                  </Alert>
                :
                  <Button type="submit" className="btn-warning" block>MODIFICA</Button>         
              }
            </Col>
          </Row> 

        </form>              
      </Col>

      <ResponseBox invalid={invalid} res={res} requestBody={requestBody} editMode="true" />  
      </Row> 
    );
  }

  // Segnala se è necessario invalidare il form 
  // se non sono stati inseriti due campi contatto
  toggleNeedsTwoContacts(isNeeded) {     
    this.setState({
      needsTwoContacts: isNeeded
    });         
  }

  // Segnala se è necessario invalidare il form 
  // se non sono stati calcolati i campi automatici
  toggleNeedsCalculation(isNeeded) {
    this.setState({
      needsCalculation: isNeeded
    });
  }

  handleSubmit(event) {    
    event.preventDefault();      
    const form = event.target;   

    // Invalida il form se non ha superato la validazione    
    if(!form.checkValidity() || this.state.needsCalculation) {
      this.setState({ 
        invalid: true, 
        displayErrors: true        
      });
      return;
    } 
    
    // // Salva il form in quanto valido, permette l'invio
    let data = new FormData(form);    
    let jsxContent = {}; 
    let requestBody = {};

    for (let i=0; i < form.length; i++) {               
      form[i].disabled = true;          
    }

    for (let name of data.keys()) {           
      const input = form.elements[name];

      if(input instanceof RadioNodeList) {
        input = [...input].find(i => i.checked);
      }

      let parserName; // Tipo di conversione che il campo necessita
      let fieldTitle; // Nome del campo da visualizzare nel riepilogo
       
      let value;

      try {
        // La proprietà dataset permette di accedere agli attributi data-* 
        // (data-parse => tipo di conversione, data-caption => nome per il riepilogo)
        parserName = input.dataset.parse; 
        value = data.get(name);

        let selVal = "";
        
        if (parserName === 'date' || parserName === 'number') {
          value = (value==='')? '-' : inputParsers[parserName](value);
        } else if (parserName === 'select') {
          // Modalita' caparra deve venire stampata estesa, non come char  
          selVal = getSelValueEsteso(value);   
          // caparraTrattenuta da stringBool a "stringa"
          value = (selVal === "Sì")? "true" :((selVal === "No")? "false" : value);
        } else if (parserName === 'select-label') {
          selVal = input.options[input.selectedIndex].innerHTML;
        } else if (parserName === 'bool') {
          selVal = selVal === "true" ? "Si" : "No";
        }
        // dimArt, subGruppo non deve essere inviato
        if ((parserName === 'dimArt') || (parserName === 'subGruppo')) {
          continue;
        } else
        // bugfix popolamento 
        if (parserName === 'noteArt') {
          value = (value==='')? '-' : value;
        }

        let separator = input.dataset.separator;
        if(separator !== undefined) {
          jsxContent[separator] = separator;
        }

        fieldTitle = input.dataset.caption;     
        
        // jsxContent contiene i dati stampati a video,
        // i valori delle select vanno mostati estesi
        jsxContent[fieldTitle] = (selVal === ""? value : selVal);                 

        requestBody[name] = value;
      } catch(err) {
        // Evita undefined error in caso di campi senza proprietà dataset     
        continue; 
      }         
      
    }
    
    // Aggiunge il token di autenticazione e il nome della richiesta
    requestBody['serialeOperatore'] = localStorage.getItem('serialeOperatore');
    requestBody['request'] = 'updateOrder'; // qui cambia rispetto a NewOrder.js

    this.setState({
      res: jsxContent,
      requestBody: requestBody,
      invalid: false,
      displayErrors: false      
    });
  }
}

// Converte date e numeri nel formato del database
const inputParsers = {
  // DD-MM-YYYY -> YYYY-MM-DD
  date(input) {
    const split = input.split('/');
    const day = split[0]
    const month = split[1];
    const year = split[2];
    return `${year}-${month}-${day}`;
  },
  // YYYY-MM-DD
  reverseDate(input) {
    const split = input.split('-');
    const day = split[2]
    const month = split[1];
    const year = split[0];
    return `${day}/${month}/${year}`;
  },
  // Int -> Double
  number(input) {
    return parseFloat(input);
  }
}

export default EditOrder;





// WEBPACK FOOTER //
// ./src/cmp/Orders/EditOrder.js